var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_19858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12.25V22.25C22 23.21 21.21 24 20.25 24H12.75V13H11.25V24H3.75C2.79 24 2 23.21 2 22.25V12.25C2 11.84 2.34 11.5 2.75 11.5H21.25C21.66 11.5 22 11.84 22 12.25Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 8.75V11.25C24 12.21 23.21 13 22.25 13H1.75C0.79 13 0 12.21 0 11.25V8.75C0 7.79 0.79 7 1.75 7H22.25C23.21 7 24 7.79 24 8.75Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 8.04112C11.7817 8.04112 11.5737 7.94613 11.4327 7.78113C11.2897 7.61613 11.2267 7.39713 11.2577 7.18113C11.6277 4.68113 13.5807 -0.046875 18.3287 -0.046875C21.0387 -0.046875 21.9997 1.41712 21.9997 2.67112C21.9997 4.90013 18.8967 8.04112 11.9997 8.04112ZM18.3287 1.45312C14.7467 1.45312 13.3867 4.85812 12.9357 6.51912C15.7617 6.38713 17.5437 5.67213 18.5697 5.06313C19.9927 4.21813 20.4997 3.27312 20.4997 2.67013C20.4997 1.77213 19.3787 1.45312 18.3287 1.45312Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.04112C5.102 8.04112 2 4.90013 2 2.67112C2 1.41712 2.962 -0.046875 5.672 -0.046875C10.419 -0.046875 12.372 4.68113 12.742 7.18113C12.773 7.39713 12.71 7.61613 12.567 7.78113C12.426 7.94613 12.218 8.04112 12 8.04112ZM5.672 1.45312C4.622 1.45312 3.5 1.77312 3.5 2.67112C3.5 3.94812 5.733 6.27413 11.064 6.52012C10.613 4.85812 9.253 1.45312 5.672 1.45312Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13V24H11.25V13H12.75Z",
    fill: "#FF8F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.59V13H11.25V7.59C11.25 7.361 11.33 7.151 11.46 7C11.6 6.85 11.79 6.75 12 6.75C12.21 6.75 12.4 6.85 12.54 7C12.67 7.15 12.75 7.36 12.75 7.59Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13H2V22.25C2 23.21 2.79 24 3.75 24H11.25V13Z",
    fill: "#B82929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.966 7H1.75C0.79 7 0 7.79 0 8.75V11.25C0 12.21 0.79 13 1.75 13H2H11.25V8.031C9.098 7.957 7.344 7.567 5.966 7Z",
    fill: "#D43A2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.672 1.45312C4.622 1.45312 3.5 1.77313 3.5 2.67113C3.5 3.94812 5.733 6.27413 11.064 6.52012C10.613 4.85812 9.253 1.45312 5.672 1.45312Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.063 6.51912C5.733 6.27413 3.499 3.94812 3.499 2.67013C3.499 1.77213 4.621 1.45213 5.671 1.45213C9.253 1.45313 10.613 4.85812 11.063 6.51912ZM5.672 -0.046875C2.962 -0.046875 2 1.41712 2 2.67112C2 4.09312 3.262 5.88513 5.965 6.99713C7.344 7.56413 9.097 7.95412 11.249 8.02812V7.58713C11.249 7.35813 11.329 7.14813 11.459 6.99713C11.599 6.84713 11.789 6.74713 11.999 6.74713V4.63213C11.015 2.34913 9.051 -0.046875 5.672 -0.046875Z",
    fill: "#DEA806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13H11.25V24H12V13Z",
    fill: "#DE7C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.75C11.79 6.75 11.6 6.85 11.46 7C11.33 7.15 11.25 7.36 11.25 7.59V8.031V13H12V6.75Z",
    fill: "#DEA806"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_19858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.dc9369c4b5277268b2c5ad6738c42de1.svg";
export { ForwardRef as ReactComponent };